import { Component, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { DialogComponent } from '../../dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { environment } from '@env';
import { buildReturnOfTotvsData } from '@shared/utils/util';
import { GetApplymentSettingsService } from '@app/services/client-general-settings/applyment/get-applyment-settings.service';

@Component({
  selector: 'app-popup-form',
  templateUrl: './dialog-popup-form.component.html',
  styleUrls: ['./dialog-popup-form.component.scss']
})
export class DialogPopupFormComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogPopupFormComponent>,
    public dateComponent: DialogComponent,
    public getApplymentSettingsService: GetApplymentSettingsService
  ) {
    this.dataComponent = dateComponent.data;
  }

  public popup;
  public defaultColor;
  public lgpdDataFromPopUp;
  public previousSubmissionData;
  public loading;
  public env = environment;
  public dataComponent: any;

  ngOnInit() {
    this.popup = this.dataComponent.data;
    const applymentModel = this.getApplymentSettingsService.getApplymentModel()
    if (applymentModel && applymentModel.settings) {
      this.defaultColor = applymentModel.settings.institutional_color ?? false;
    }
    this.lgpdDataFromPopUp = this.dataComponent.lgpdDataFromPopUp;
    this.previousSubmissionData = this.popup.previousSubmissionData;
    buildReturnOfTotvsData(this.popup.query, this.popup.content);

    (window as any).psClosePopUp = () => {
      this.dialogRef.close();
    };
  }
}
